import React, { Component, Fragment } from 'react';
import { SettingOutlined } from '@ant-design/icons';
import SettingPanel from './settingPanel';
import './index.css';

class PowerSINetManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settingVisible: false,
    }
  }

  updateSettingVisible = (visible) => {
    this.setState({
      settingVisible: visible
    })
  }
  render() {
    const { settingVisible } = this.state;
    return (
      <Fragment>
        <div>
          <span className="font-bold sierra-setup-title-color">PowerSI Net Manager</span>
          <SettingOutlined
            className='sierra-setup-setting-icon'
            onClick={() => this.updateSettingVisible(true)}
          />
        </div>
        {settingVisible ? <SettingPanel
          updateSettingVisible={this.updateSettingVisible} />
          : null}
      </Fragment>
    )
  }
}

export default PowerSINetManager;
